import { useEffect, useState } from 'react';

export type Consent = {
  analytics: boolean;
  targeting: boolean;
};

const DENIED: Consent = { analytics: false, targeting: false };

function read(): Consent {
  return window.rrConsent || DENIED;
}

export function useConsent(): Consent {
  const [consent, setConsent] = useState<Consent>(read);

  useEffect(() => {
    const update = () => setConsent(read());

    update();

    window.addEventListener('rr-consent-changed', update);

    return () => window.removeEventListener('rr-consent-changed', update);
  }, []);

  return consent;
}

export default useConsent;
